"use client";

import { useEffect } from "react";

export default function NutritionModal({ itemName, nutritionalInfo, onClose }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}>
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <div className="flex items-start justify-between p-5 border-b">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Nutritional Info</h2>
            <p className="text-sm text-gray-700 mt-0.5">{itemName}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 text-2xl leading-none ml-4 flex-shrink-0"
            aria-label="Close">
            ×
          </button>
        </div>

        <div className="overflow-y-auto p-5 space-y-5">
          {nutritionalInfo.map((group, gi) => (
            <div key={gi}>
              <h3 className="font-bold text-gray-900 mb-2">{group.ingredientName}</h3>
              <div className="space-y-1">
                {group.facts.map((fact, fi) => (
                  <div key={fi} className="flex justify-between text-sm text-gray-700">
                    <span>{fact.property}</span>
                    <span className="font-medium text-gray-900">{fact.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
